import request from '@index/utils/request'

export function handlePageQueryGroupsettingy(data) { //分页查询
	return request({
		url: 'groupsetting/pageQueryGroupsetting',
		method: 'post',
		data
	})
}


export function handleDeleteGroupsetting(matchId) { //删除组别设项
	return request({
		url: 'groupsetting/deleteGroupsetting',
		method: 'post',
		params: {
			matchId: matchId
		}
	})
}

export function handleSave(data) { //保存组别设项（行数据）
	return request({
		url: 'groupsetting/save',
		method: 'post',
		data
	})
}

export function handleAgeControll(data) { //启用停用年龄控制
	return request({
		url: 'groupsetting/ageControll',
		method: 'post',
		data
	})
}



export function handleDownload(matchId) { //启用停用年龄控制
	return request({
		url: 'groupsetting/download',
		method: 'post',
		responseType: 'blob',
		params: {
			matchId: matchId
		}
	})
}


export function handleSetGroupsetttingSignupStatus(data) { //设置组别报名状态
	return request({
		url: 'groupsetting/setGroupsetttingSignupStatus',
		method: 'post',
		data
	})
}

export function handleaAddGroup(data) { 
	return request({
		url: 'groupsetting/addGroup',
		method: 'post',
		data
	})
}
// 保存组别分类
export function saveGroupClassify(data) { 
	return request({
		url: 'groupClassify/saveGroupClassify',
		method: 'post',
		data
	})
}
// 分页查询组别分类
export function pageGroupClassify(data) { 
	return request({
		url: 'groupClassify/pageGroupClassify',
		method: 'post',
		data
	})
}
// 删除组别分类
export function deleteGroupClassify(data) { 
	return request({
		url: 'groupClassify/deleteGroupClassify',
		method: 'post',
		data
	})
}
// 根据组别分类id查询组别明细
export function pageGroupDetailsByGroupClassifyId(data) { 
	return request({
		url: 'groupClassify/pageGroupDetailsByGroupClassifyId',
		method: 'post',
		data
	})
}
// 组别分类添加组别明细
export function groupClassifyAddGroupDetails(data) { 
	return request({
		url: 'groupClassify/groupClassifyAddGroupDetails',
		method: 'post',
		data
	})
}
// 分页查询待选择组别
export function pageWaitSelectGroups(data) { 
	return request({
		url: 'groupClassify/pageWaitSelectGroups',
		method: 'post',
		data
	})
}
// 删除组别分类下的组别
export function deleteGroupClassisfyGroupById(data) { 
	return request({
		url: 'groupClassify/deleteGroupClassisfyGroupById',
		method: 'post',
		data
	})
}
// 根据组别分类下载对应组别
export function downloadGroupsOfGroupClass(data) { 
	return request({
		url: 'groupClassify/out/downloadGroupsOfGroupClass',
		method: 'post',
		responseType: 'blob',
		data,
		params:{
			...data
		}
	})
}
// 查询下拉选择赛事组别分类
export function queryDropdownSelectGroupClassifies(data) { 
	return request({
		url: 'limitSignupRule/queryDropdownSelectGroupClassifies',
		method: 'post',
		data
	})
}
// 分页查询限制报名规则
export function pageLimitSignupRules(data) { 
	return request({
		url: 'limitSignupRule/pageLimitSignupRules',
		method: 'post',
		data
	})
}
// 保存限制报名规则
export function saveLimitSignupRule(data) { 
	return request({
		url: 'limitSignupRule/saveLimitSignupRule',
		method: 'post',
		data
	})
}
// 根据id删除限制报名规则
export function deleteLimitSignupRuleById(data) { 
	return request({
		url: 'limitSignupRule/deleteLimitSignupRuleById',
		method: 'post',
		data
	})
}
// 分页查询互斥规则
export function pageMutualExclusionRules(data) { 
	return request({
		url: 'mutualExclusionRule/pageMutualExclusionRules',
		method: 'post',
		data
	})
}
// 互斥规则-查询下拉选择赛事组别分类
export function mqueryDropdownSelectGroupClassifies(data) { 
	return request({
		url: 'mutualExclusionRule/queryDropdownSelectGroupClassifies',
		method: 'post',
		data
	})
}
// 保存互斥规则
export function saveMutualExclusionRule(data) { 
	return request({
		url: 'mutualExclusionRule/saveMutualExclusionRule',
		method: 'post',
		data
	})
}
// 删除互斥规则
export function deleteMutualExclusionRuleById(data) { 
	return request({
		url: 'mutualExclusionRule/deleteMutualExclusionRuleById',
		method: 'post',
		data
	})
}
export function deleteAllGroupClassifyGroups(data) { 
	return request({
		url: 'groupClassify/deleteAllGroupsByClassifyId',
		method: 'post',
		data
	})
}

